import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { callWrite, INSERT_FAVORITE, INSERT_FAVORITE_LIST } from "../../amplify/appsync/write";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Favorite } from "../../amplify/appsync/query";


interface FavoriteNewListModalProps {
    show: boolean;
    setShow: any;
    lists: string[];
    setLists: any;
    contextMenu: any;
    updateCsnToFavorites: any;
}


const MAX_LIST_SIZE = 40;


export const FavoriteNewListModal = (props: FavoriteNewListModalProps) => {

    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [listName, setListName] = useState<string>("");

    useEffect(() => {
        setListName("");
    }, []);

    const handleClose = () => {
        props.setShow(false);
    };

    const saveFavorite = (listName: string) => {
        if (props.contextMenu && props.contextMenu.patient) {
            callWrite({
                operation: INSERT_FAVORITE,
                favorite_time: new Date().getTime(),
                favorite_type: listName,
                csn: props.contextMenu.patient.csn,
                mrn: props.contextMenu.patient.mrn,
                internal_csn: props.contextMenu.patient.internal_csn,
                internal_mrn: props.contextMenu.patient.internal_mrn,
            })
            .then((output: Favorite[]) => {
                console.log("Saved favorite", output[0]);
                props.updateCsnToFavorites(props.contextMenu.patient.csn, listName, output[0]);
            });
        }
    }

    const saveList = () => {
        if (listName && listName !== "favorite" && !props.lists.includes(listName)) {
            setIsSaving(true);
            callWrite({
                operation: INSERT_FAVORITE_LIST,
                list_name: listName,
            })
            .then((output: any) => {
                console.log("Saved favorite list", output);
                setIsSaving(false);
                props.setLists([
                    ...props.lists,
                    listName,
                ]);
                
                props.setShow(false);
            });

            saveFavorite(listName);
        } else {
            setIsSaving(false);
            props.setShow(false);
        }
    };

    const handleInputChange = (event: any) => {
        if (event.target.value.length <= MAX_LIST_SIZE) {
            setListName(event.target.value);
        }
    };

    return (
        <Modal show={props.show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Create List</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-right">
                    <Form.Label>
                        <small style={{color: listName.length >= MAX_LIST_SIZE ? "red" : undefined}}>{listName.length}/{MAX_LIST_SIZE}</small>
                    </Form.Label>
                </div>
                <Form.Control type="input" placeholder="List name..." value={listName} onChange={handleInputChange} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={saveList} disabled={listName.length <= 0 || isSaving}>
                    {
                        isSaving ? (
                            <FontAwesomeIcon icon={faSpinner} spin />
                        ) : (
                            <>Create List</>
                        )
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    )
};
